
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { pressureData } from '@/data/water-analytics-data';
import ChartLegend from '@/components/charts/ChartLegend';

const WaterFlowChart = () => {
  // We'll use pressure data for this flow chart since waterFlowData is missing
  // This is a temporary solution to fix the build error
  const flowData = pressureData.map(item => ({
    ...item,
    flow: (item.pressure * 0.8).toFixed(2)  // Convert pressure to flow for demo
  }));

  return (
    <AnimatedCard 
      animation="fade-up"
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardHeader>
        <CardTitle>Water Flow Analysis (L/min)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={flowData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="time" />
              <YAxis domain={[2.5, 3.5]} />
              <Tooltip 
                formatter={(value) => [`${value} L/min`, 'Flow Rate']}
                contentStyle={{ 
                  borderRadius: '8px', 
                  border: 'none', 
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
                }}
              />
              <Line 
                type="monotone" 
                dataKey="flow" 
                stroke="#0EA5E9" 
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
          
          {/* Add Chart Legend below the chart */}
          <ChartLegend 
            payload={[
              { dataKey: 'flow', value: 'Flow Rate (L/min)', color: '#0EA5E9' }
            ]}
          />
        </div>
      </CardContent>
    </AnimatedCard>
  );
};

export default WaterFlowChart;
